// @flow
import { createFormReducer } from 'redux-pure-form';
import type { Reducer } from 'redux';

import omit from '../utils/omit.js';

import { ADD_PRODUCT, SAVE_PRODUCT, DELETE_PRODUCT, defaultProduct } from './products.const.js';

import type { Products, Product } from './products.types.js';

export const products = (state: Products = {}, action: Action) => {
  switch (action.type) {
    case ADD_PRODUCT:
    case SAVE_PRODUCT:
      return {
        ...state,
        [action.payload.product.id]: action.payload.product
      };
    case DELETE_PRODUCT:
      return omit(state, action.payload.id);
    default:
      return state;
  }
};

const productFormHandler: Reducer<Product, Action> = createFormReducer(
  'productForm',
  defaultProduct
);
export const productForm = (state: Product = defaultProduct, action: Action) =>
  productFormHandler(state, action);

export const URL = (state: $ElementType<ReduxState, 'URL'> = {}) => state;
